import ContractsCargoTaxiDetailsResponse, {
  ContractsCargoTaxiDetailsResponseItem,
  ContractsCargoTaxiDetailsResponseItemModel,
  ContractsCargoTaxiDetailsResponseItemCargoCompany,
} from "../../../../api/raily/contracts/cargo-taxi/details/contracts-cargo-taxi-details.response";
import BillingModel from "../../../../types/billing-model";
import DateRange from "../../../../types/date-range";
import ContractsCargoTaxiDetails, {
  ContractsCargoTaxiDetailsCargoCompany,
} from "./contracts-cargo-taxi-details";

const createBillingModel = (
  responseModel: ContractsCargoTaxiDetailsResponseItemModel,
): BillingModel => {
  switch (responseModel) {
    case ContractsCargoTaxiDetailsResponseItemModel.AB:
      return BillingModel.AB;
    case ContractsCargoTaxiDetailsResponseItemModel.ABA:
      return BillingModel.ABA;
    case ContractsCargoTaxiDetailsResponseItemModel.OTHER:
      return BillingModel.OTHER;
    case ContractsCargoTaxiDetailsResponseItemModel.SABS:
      return BillingModel.SABS;
  }
};

const createCargoCompany = (
  responseCargoCompany: ContractsCargoTaxiDetailsResponseItemCargoCompany,
): ContractsCargoTaxiDetailsCargoCompany => {
  return {
    displayName: responseCargoCompany.displayName,
  };
};

const createDateRange = (
  item: ContractsCargoTaxiDetailsResponseItem,
): DateRange => {
  return {
    from: item.validSince,
    to: item.validTo,
  };
};

const create = (
  response: ContractsCargoTaxiDetailsResponse,
): ContractsCargoTaxiDetails => {
  return {
    periodOfValidity: createDateRange(response.data),
    isActive: !response.data.disabled,
    billingModel: createBillingModel(response.data.model),
    distanceRate: response.data.distanceRate,
    stoppingRate: response.data.haltingTimeRate,
    freeStoppingPeriodMinutes: response.data.haltingTimeAfterMinutes,
    cargoCompany: createCargoCompany(response.data.cargoCompany),
    discountPercentLimit: response.data.discountLimit,
    isOrderPublishingAllowed: response.data.publishingAllowed,
    isTollRoadsDuringOrderAllowed: response.data.allowChargeDuringRide,
    isTollRoadsWhileArrivalAllowed: response.data.allowChargeWhileApproaching,
    isTollRoadsWhileReturningAllowed: response.data.allowChargeWhileReturning,
    contactPassengerAfterMinutes: response.data.contactPassengerAfterMinutes,
    cancelByTaxiAllowed: response.data.cancelByTaxiAllowed,
    editByTaxiAllowed: response.data.editByTaxiAllowed,
  };
};

const contractsCargoTaxiDetailsFactory = {
  create,
};

export default contractsCargoTaxiDetailsFactory;
